import { useStore } from '../FronteggStoreContext';
import { useSnapshot } from '../useSnapshot';
const defaultMapper = {
  state: state => state,
  actions: actions => actions
};
export function useAuditsState(stateMapper = defaultMapper.state) {
  const state = useStore().store.auditLogs;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return stateMapper(useSnapshot(state));
}
export const useAuditsActions = () => {
  return useStore().stateActions.auditLogs;
};